import {Context} from 'react'
import {RuntimeContext} from '../../../../../commons/components/runtime-context/runtime-context'
import {MembersPageAppProps} from '../../../interface'

export const MembersPageRuntimeContext: Context<MembersPageAppProps> = RuntimeContext
